export default {
    assessment          : 1,
    budgetedmeasure     : 2,
    falsealarm          : 3,
    retrofit            : 4,
    emergency           : 5,
    issue_person        : 6,
    assessmentcost      : 8,
    plannedrepair       : 9,
    maintenancerepair   : 10,
    specialoperation    : 11,
    issue_common        : 12,
    vandalism           : 13,
    maintenance         : 14,
    revision            : 15,
    emergencymaintenance: 16,
    guardcost           : 17,
    maintenanceProcess  : 18,
    repairassessment    : 19,
    assessmentinvoice   : 20,

    isIssue (type) {
        if (!type) {
            return false;
        }

        return this.issue_common     === type
            || this.issue_person     === type
            || this.vandalism        === type
            || this.specialoperation === type
            || this.falsealarm       === type
    },

    isInvoice (type) {
        if (!type) {
            return false;
        }

        return this.assessmentinvoice    === type
            || this.guardcost            === type
            || this.emergencymaintenance === type
            || this.assessmentcost       === type
            || this.emergency            === type
    },

    isRepair (type) {
        if (!type) {
            return false;
        }

        return this.plannedrepair    === type
            || this.repairassessment === type
            || this.revision         === type
            || this.retrofit         === type
            || this.budgetedmeasure  === type
    }
}